import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=4a10d002&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=ts&"
export * from "./InfoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=4a10d002&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10d002",
  null
  
)

export default component.exports